import api from './api';
import { API_ENDPOINTS } from '../utils/constants';

export const repairService = {
  // Get all repair articles
  getAll: async (params = {}) => {
    const response = await api.get(API_ENDPOINTS.REPAIRS, { params });
    return response.data;
  },

  // Get single repair article
  getById: async (id) => {
    const response = await api.get(API_ENDPOINTS.REPAIR_DETAIL(id));
    return response.data;
  },

  // Create repair article
  create: async (formData) => {
    const response = await api.post(API_ENDPOINTS.REPAIRS, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  // Update repair article
  update: async (id, formData) => {
    const response = await api.put(API_ENDPOINTS.REPAIR_DETAIL(id), formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  // Delete repair article
  delete: async (id) => {
    const response = await api.delete(API_ENDPOINTS.REPAIR_DETAIL(id));
    return response.data;
  },

  // Delete repair image - FIXED VERSION
  deleteImage: async (repairId, imageId) => {
    // Use the generic image delete endpoint from your backend
    // Your backend has: DELETE /api/images/{image_id}
    const response = await api.delete(`/images/${imageId}`);
    return response.data;
  },
};